import { TilePos } from '../types';
import { TREAT_SPAWN } from '../maps/levels';

export interface Treat {
  col: number;
  row: number;
  points: number;
  name: string;
  active: boolean;
  timer: number;
}

const TREAT_TABLE: { name: string; points: number }[] = [
  { name: 'apple', points: 100 },
  { name: 'pretzel', points: 300 },
  { name: 'cupcake', points: 500 },
  { name: 'fish', points: 700 },
  { name: 'pie', points: 1000 },
  { name: 'cake', points: 2000 },
  { name: 'steak', points: 3000 },
  { name: 'crown', points: 5000 },
];

export function getTreatForLevel(level: number): { name: string; points: number } {
  const idx = Math.min(level - 1, TREAT_TABLE.length - 1);
  return TREAT_TABLE[idx];
}

export function createTreat(level: number): Treat {
  const info = getTreatForLevel(level);
  return {
    col: TREAT_SPAWN.col,
    row: TREAT_SPAWN.row,
    points: info.points,
    name: info.name,
    active: true,
    timer: 10,
  };
}
